// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__zWFID","rootCenter":"LoadMoreObserver_rootCenter__19_EV","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3qr1W"};